module.exports = __webpack_public_path__ + "static/img/Ronald.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Ronald.png
// module id = lNNZ
// module chunks = 1